import type { Api } from '@pflegenavi/shared-frontend/platform';
import {
  getPhoenixApiTenantUrl,
  modify,
} from '@pflegenavi/shared-frontend/platform';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';

export interface CreateStripeAccountResponse {
  id: string;
  url: string;
  currently_due: boolean;
  onboarding_started: boolean;
}

export interface IStripePhoenixApi extends Api {
  createStripeAccount(dataIn?: {
    body?: unknown;
  }): Promise<CreateStripeAccountResponse>;
  refreshStripeAccount(dataIn?: {
    body?: unknown;
  }): Promise<CreateStripeAccountResponse>;
}

export class StripePhoenixApi implements IStripePhoenixApi {
  createStripeAccount: IStripePhoenixApi['createStripeAccount'];
  refreshStripeAccount: IStripePhoenixApi['refreshStripeAccount'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    const baseUrl = getPhoenixApiTenantUrl('service-provider', apiUrl);

    this.createStripeAccount = modify({
      authContext,
      method: 'POST',
      url: `${baseUrl}/stripe/account`,
    });

    this.refreshStripeAccount = modify({
      authContext,
      method: 'POST',
      url: `${baseUrl}/stripe/account/refresh`,
    });
  }
}
